import {responses} from "@/utils/responses";
import {utils} from "@/utils/utils";
import Swal from "sweetalert2";
import {errorHandler} from "@/services/errorHandler";
import copy from 'copy-to-clipboard';
import {authentication} from "@/services/auth";
import {dateTimeManager} from "@/services/TimeManager";
import Vue from 'vue'
import axios from 'axios'


window.axios = axios;
Array.prototype.removeIf = function (callback) {
    let i = 0;
    while (i < this.length) {
        if (callback(this[i], i)) {
            this.splice(i, 1);
        } else {
            ++i;
        }
    }
};
window.printApi = `https://overflow.abc.co.zm/PrintApi/`;
window.ticketApi2 = `https://lna.abc.co.zm/PettyCashApi/api/v1/`;

// window.ticketApi = `http://mcc:8181/TicketApp/`
// window.ticketApi = `https://lna.abc.co.zm/TicketApp/`
// window.ticketApi = `http://Vincent:8080/TicketApp/`;
 // window.ticketApi = `http://kabs:8080/TicketApp/`

//test env
// window.ticketApi = 'https://lna.abc.co.zm/TicketAppTest/';
// --------------------------------------------------------
// window.synergy4 = 'https://lna.abc.co.zm/SynergyApiTest/';
//test env

// //test env
window.ticketApi = 'http://localhost:8282/TicketApp/';
// //--------------------------------------------------------
window.synergy4 = 'http://localhost:8282/SynergyApi/';
// //test env


window.ticketApiV2 = ticketApi;


 // window.synergy4 = 'https://lna.abc.co.zm/SynergyApi/'

window.KazangPaymentGatewayV2 = 'https://lna.abc.co.zm/KazangPaymentGateway/V2';
// window.backOfficeTomcatApi = `http://192.168.1.216:8080/backoffice/`
// window.backOfficeTomcatApi = `http://192.168.1.244:8181/Lyt-SoftBackOfficeApi/`

window.backOfficeTomcatApi = `https://overflow.abc.co.zm/Lyt-SoftBackOfficeApi/`;



 //window.lytSIApi = 'http://http://192.168.1.125:8080/lytSI/api/v1/'
window.lytSIApi='https://lna.abc.co.zm/lytSI/api/v1/'
window.smartInvoiceSignupApi='https://lna.abc.co.zm/lytSI/api/v1/smart-invoice-signup/'

window.Franchise_OnlineServer='https://overflow.abc.co.zm/Franchise_OnlineServer/'
// window.Franchise_OnlineServer='http://mcc:8181/Franchise_OnlineServer/'

window.OnlineSalesServer='https://overflow.abc.co.zm:8443/OnlineSalesServer/'
// window.OnlineSalesServer='http://mcc:8181/OnlineSalesServer/'

window.synergy6 = synergy4 + 'api/v2/'
// window.synergy = synergy4 + 'api/v1/'
window.synergy = synergy4
window.synergy1 = synergy4 + 'api/v1/' //all-pending-requests
window.synergy2 = synergy4 + 'api/v1/'// follow up customer
window.synergy3 = synergy4 // dispatch pending
window.synergy5 = synergy4 + 'api/v1/' // job card management

window.subscriptionApi = `http://localhost:8282/SubscriptionManager/api/`
// window.subscriptionApi = `https://overflow.abc.co.zm:8443/SubscriptionManager/api/`

window.chatApi = `https://lna.abc.co.zm/ChatLinkChrilan/supportChat/`
// window.chatApi = `http://192.168.1.38:8443/ChatLinkChrilan/supportChat/`

window.registrationApi = `https://chrilantech.com/regmac/api/`

window.SearchTicket = ticketApi+`ticket/v2/`

window.serverApi = `https://overflow.abc.co.zm:8443/OnlineSalesServer/`
window.franchiseTomcatApi = `https://overflow.abc.co.zm/Franchise_OnlineServer/`

window.stocklistApi = `https://overflow.abc.co.zm/FranchiseSpringServer/`

// window.leave = synergy4+`leave`
window.disciplinary = synergy4+`disciplinaryAction`
window.image = synergy4+`getImageByRequestID`


// window.stocklistApi = `http://localhost:8181/FranchiseSpringServer/`
window.stocklistApiimport = franchiseTomcatApi;
window.fundingRequst = ticketApi2+'statistics/';
window.responses = responses;
window.Swal = Swal;
window.errorHandler = errorHandler;
window.authenticator = authentication;
Vue.prototype.$dateTimeManager = dateTimeManager;
Vue.prototype.$utils = utils;
window.$utils = utils;

window.encodeObjectAsUrlParams = function encodeObjectAsUrlParams(obj, prefix = '') {
    const encodedParams = [];
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const paramName = prefix ? `${prefix}[${key}]` : key;
            if (value instanceof Object) {
                encodedParams.push(encodeObjectAsUrlParams(value, paramName));
            } else {
                const encodedValue = encodeURIComponent(value);
                encodedParams.push(`${paramName}=${encodedValue}`);
            }
        }
    }
    return encodedParams.join('&');
}
window.copy = copy;
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
window.pageOptions = {
    enabled: true,
    mode: 'pages',
    perPage: 10,
    position: 'bottom',
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: 'page', // for 'pages' mode
}

window.isValidString = (string) => {
    if (!string) return false;
    string = string.toString().trim();
    return !(string === `null` || string === `undefined` || string === ``);

}

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}
